(function () {
    'use strict';

    angular.module('app.paymentTemplates', [
        'app.core',
        'app.widgets'
    ]);
})();
